import { render, staticRenderFns } from "./SolicitacaoProdutos.vue?vue&type=template&id=76465f64&scoped=true&"
import script from "./SolicitacaoProdutos.vue?vue&type=script&lang=js&"
export * from "./SolicitacaoProdutos.vue?vue&type=script&lang=js&"
import style0 from "./SolicitacaoProdutos.vue?vue&type=style&index=0&id=76465f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76465f64",
  null
  
)

export default component.exports